import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

/**
 * Reusable Card component for events and tournaments
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render inside the card
 * @param {string} props.className - Additional CSS class name
 * @param {Function} props.onClick - Click handler for the card
 * @param {boolean} props.disabled - Whether the card is disabled
 * @param {Object} props.style - Inline styles
 * @param {string} props.testId - Test ID for testing
 */
export const Card = ({
  children,
  className,
  onClick,
  disabled = false,
  style,
  testId,
  ...props
}) => {
  const cardClasses = classNames(
    styles.card,
    {
      [styles.disabled]: disabled,
    },
    className
  )

  return (
    <div
      className={cardClasses}
      onClick={disabled ? undefined : onClick}
      style={style}
      data-testid={testId}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card
